import {
  formatDate,
  formatVariantInheritance,
  isWindow,
  unique
} from '@/@core/utils/utils'
import Index from '@/views/analyze/Index'
import {
  Typography,
  Stack,
  Divider,
  FormControlLabelProps,
  styled,
  useRadioGroup,
  Card,
  CardContent,
  Badge,
  Tooltip,
  Rating,
  Slide,
  Chip,
  TooltipProps,
  Button,
  IconButton,
  Backdrop,
  CircularProgress
} from '@mui/material'
import * as XLSX from 'xlsx'
import { Box } from '@mui/system'
import {
  Circle,
  CircleHalfFull,
  Close,
  CommentOutline,
  Delete,
  MenuDown,
  Plus
} from 'mdi-material-ui'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation, useQuery } from 'react-query'
import { DataGrid, GridColDef, GridRowId } from '@mui/x-data-grid'
import AntdTables, {
  ColumnTypes,
  DragHandle
} from '@/@core/components/tables-antd'
import {
  deleteVariantReports,
  editVariantReports,
  getVariantReports,
  ReportsVariants,
  Variation
} from '@/@core/services/app.service'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { useRouter } from 'next/router'
import TanStackTable from '@/@core/components/tanstack-tables'
import { ColumnDef } from '@tanstack/react-table'
import { jsonToCSV } from 'react-papaparse'
import { NObject } from '@/@core/components/filter-variants'
import _ from 'lodash'
import { utils } from 'xlsx'
import Columns1Thalassemia from '@/views/analyze/children/table-columns/columns1Thalassemia'
import Columns1CNV from '@/views/analyze/children/table-columns/columns1CNV'
import Columns1STR from '@/views/analyze/children/table-columns/columns1STR'
import Columns1 from '@/views/analyze/children/table-columns/columns1'
import { getVariantId } from '@/views/analyze/children/report-children/new-report'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  }
}

const Badges = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: '-10px',
    backgroundColor: 'rgb(110,200,229)'
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

const color = [
  {
    key: 'pathogenic',
    value: 'pathogenic',
    color: 'rgba(229,38,35,0.8)'
  },
  {
    key: 'likely pathogenic',
    value: 'likely pathogenic',
    color: 'rgba(221,109,32,0.8)'
  },
  {
    key: 'drug response',
    value: 'drug response',
    color: 'rgb(46, 125, 50,0.8)'
  },
  {
    key: 'uncertain significance',
    value: 'uncertain significance',
    color: 'rgb(240,239,240,0.4)'
  },
  {
    key: 'likely benign',
    value: 'likely benign',
    color: 'rgb(107,148,200,0.8)'
  },
  {
    key: 'benign',
    value: 'benign',
    color: 'rgb(109,56,149,0.8)'
  },
  {
    key: 'loss of function',
    value: 'loss of function',
    color: 'rgb(237, 108, 2,0.8)'
  }
]

const GLScolor = [
  {
    key: 'pathogenic',
    value: 'pathogenic',
    color: 'rgb(218,150,148)'
  },
  {
    key: 'likely pathogenic',
    value: 'likely benign',
    color: 'rgb(245,182,193)'
  },
  {
    key: 'drug response',
    value: 'drug response',
    color: 'rgb(186,204,147)'
  },
  {
    key: 'uncertain significance',
    value: 'uncertain significance',
    color: 'rgb(240,239,240)'
  },
  {
    key: 'likely benign',
    value: 'likely benign',
    color: 'rgb(107,148,200)'
  },
  {
    key: 'benign',
    value: 'benign',
    color: 'rgb(64,113,190)'
  },
  {
    key: 'loss of function',
    value: 'loss of function',
    color: 'rgb(246,209,139)'
  }
]

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  // [`& .${tooltipClasses.tooltip}`]: {
  //   backgroundColor: 'rgba(97, 97, 97)',
  //   color: 'rgb(255, 255, 255)',
  //   maxWidth: 220,
  //   fontSize: theme.typography.pxToRem(12),
  //   border: '1px solid #dadde9'
  // }
}))

const TypographyA = styled(Typography)(() => ({
  fontSize: '0.8rem',
  color: 'inherit'
}))

const SelectReportRow = (props: any) => {
  const { t, i18n } = useTranslation()
  const router = useRouter()

  const { id } = router.query
  const type = router.asPath.includes('/samples') ? 'sample' : 'analysis'

  const [page, setPage] = React.useState({})
  const [sortQuery, setSortQuery] = React.useState<any>({
    f: -1
  })
  const tableRef = React.useRef<any>()
  const [value, setValue] = React.useState(0)
  const [value2, setValue2] = React.useState(0)
  const [backOpen, setBackOpen] = React.useState(false)
  const columns1ThalassemiaRef = React.useRef<any>()
  const columns1CNVRef = React.useRef<any>()
  const columns1STRRef = React.useRef<any>()
  const columns1DefaultRef = React.useRef<any>()
  const [data, setData] = React.useState<any[]>([])
  const [types, setTypes] = React.useState<any[]>([])
  const [thalassemiaData, setThalassemiaData] = React.useState<any[]>([])
  const [rowSelection, setRowSelection] = React.useState<GridRowId[]>([])
  const [selectRowKey, setSelectRowKey] = React.useState<any[]>([])
  const [selectThalassemiaRowKey, setSelectThalassemiaRowKey] = React.useState<
    any[]
  >([])

  const defaultColumns: ColumnDef<Variation>[] = React.useMemo(() => {
    let column = []

    if (columns1DefaultRef.current && columns1DefaultRef.current.column) {
      column = columns1DefaultRef.current.column
    }

    return column
  }, [columns1DefaultRef, columns1DefaultRef.current])

  const defaultColumns1: ColumnDef<Variation>[] = React.useMemo(() => {
    let column = []

    if (columns1CNVRef.current && columns1CNVRef.current.column) {
      column = columns1CNVRef.current.column
    }

    return column
  }, [columns1CNVRef, columns1CNVRef.current])

  const defaultColumns2: ColumnDef<Variation>[] = React.useMemo(() => {
    let column = []

    if (columns1STRRef.current && columns1STRRef.current.column) {
      column = columns1STRRef.current.column
    }

    return column
  }, [columns1STRRef, columns1STRRef.current])

  const defaultColumns3: ColumnDef<Variation>[] = React.useMemo(() => {
    let column = []

    if (
      columns1ThalassemiaRef.current &&
      columns1ThalassemiaRef.current.column
    ) {
      column = columns1ThalassemiaRef.current.column
    }

    return column
  }, [columns1ThalassemiaRef, columns1ThalassemiaRef.current])

  const handleRemove = (reportId: number, selectRowKey: any[]) => {
    if (data.length === 1 || selectRowKey.length === data.length) {
      deleteReportsVariant.mutateAsync(reportId)
    } else {
      const params: ReportsVariants = {
        id: reportId,
        objectId: id as unknown as number,
        objectType: type as any,
        snvVariants: JSON.stringify(
          data
            .filter((item) => {
              if (item.AnnotSV_ID) {
                return !selectRowKey.some(
                  (i) => i.AnnotSV_ID === item.AnnotSV_ID
                )
              } else if (item.dbSNP_IDs) {
                return !selectRowKey.some((i) => i.dbSNP_IDs === item.dbSNP_IDs)
              } else {
                return !selectRowKey.some((i) => i.keyId === item.keyId)
              }
            })
            .map((items: any) => {
              delete items.transcript_list
              delete items.Index
              delete items.GeneIndex
              return {
                ...items
              }
            })
        ),
        cnvVariants: null,
        createdAt: new Date(),
        updatedAt: new Date()
      }

      //

      editReportVariant.mutateAsync(params)
    }
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  const { refetch: reportsVariantsRefetch, data: reportsVariants } = useQuery<{
    list: ReportsVariants[]
  }>({
    queryKey: ['reportsVariants', id],
    queryFn: () => {
      setBackOpen(true)

      return getVariantReports({ objectId: id, objectType: type } as any)
    },
    keepPreviousData: true,
    onSuccess: async (data: any) => {
      if (data.list && data.list.length) {
        //
        const types = Array.from(
          new Set(
            data.list[0].snvVariants.map((item: any) => item.variantsType)
          )
        )

        setTypes(types)

        const list = unique(
          data.list[0].snvVariants
            .filter((i: any) => !i.hb_name)
            .map((item: any, index: number) => {
              item.keyId = getVariantId(item)

              return {
                ...item,
                type: t(item.variantsType),
                ReportVariantsId: data.list[0].id,
                id: index
              }
            }),
          'keyId'
        )

        setData(list)
        const ThalassemiaRList = unique(
          data.list[0].snvVariants
            .filter((i: any) => i.hb_name)
            .map((item: any, index: number) => {
              item.keyId = getVariantId(item)

              return {
                ...item,
                type: t(item.variantsType),
                ReportVariantsId: data.list[0].id,
                id: index
              }
            }),
          'keyId'
        )

        setThalassemiaData(ThalassemiaRList)
      } else {
        setData([])

        setThalassemiaData([])
      }
    },
    onSettled: () => {
      setBackOpen(false)
    }
  })

  const deleteReportsVariant = useMutation({
    mutationFn: async (data: number) => await deleteVariantReports(data),
    onSuccess: (data) => {
      //post返回的结果
      reportsVariantsRefetch()
    }
  })

  const editReportVariant = useMutation({
    mutationFn: async (data: ReportsVariants) => await editVariantReports(data),
    onSuccess: (data: ReportsVariants) => {
      //post返回的结果
      // refetch()
      reportsVariantsRefetch()

      //
    }
  })

  return (
    <Box width={1600}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 999 }}
        open={backOpen}
        id="backdrop"
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Columns1Thalassemia
        ref={columns1ThalassemiaRef}
        setCurrent={() => {
          //
        }}
      />

      <Columns1CNV
        ref={columns1CNVRef}
        setCurrent={() => {
          //
        }}
        analysisInfo={props.analysisInfo}
      />

      <Columns1
        ref={columns1DefaultRef}
        analysisInfo={props.analysisInfo}
        query={props.query}
      />

      <Columns1STR
        ref={columns1STRRef}
        setCurrent={() => {
          //
        }}
      />

      <Card>
        <CardContent>
          {data && data.length ? (
            <Stack spacing={2}>
              <Box textAlign={'right'}>
                <Button
                  size="small"
                  variant="contained"
                  sx={{
                    mr: 4
                  }}
                  onClick={() => {
                    const reportsVariantsId = reportsVariants?.list[0].id
                    if (reportsVariantsId)
                      handleRemove(reportsVariantsId, [
                        ...selectRowKey,
                        ...selectThalassemiaRowKey
                      ])
                  }}
                >
                  {t('delete')}
                </Button>

                <Button
                  size="small"
                  variant="contained"
                  onClick={() => {
                    const arr = _.cloneDeep([
                      ...selectRowKey,
                      ...selectThalassemiaRowKey
                    ]).map((item) => {
                      const inheritance_OMIMValue = item.OMIM?.omimData
                        .map((item: any) => {
                          const inheritances: string[] = []

                          if (
                            item &&
                            item.clinicalSynopsis &&
                            item.clinicalSynopsis.INHERITANCE &&
                            Array.isArray(item.clinicalSynopsis.INHERITANCE)
                          ) {
                            item.clinicalSynopsis.INHERITANCE.forEach(
                              (str: string) =>
                                inheritances.push(str.toLowerCase())
                            )
                          }
                          const inheritance = formatVariantInheritance(
                            Array.from([...new Set(inheritances)]).join(',')
                          )

                          return {
                            ...item,
                            inheritance
                          }
                        })
                        .map(
                          (items: any) =>
                            `(${items.inheritance ? items.inheritance : '.'})-${
                              items.phenoName
                            }-${items.pheno_name_cn}`
                        )
                        .join(';')

                      if (inheritance_OMIMValue)
                        item.inheritance_OMIMValue = inheritance_OMIMValue

                      if (item.exon) item.exon = `\t${item.exon}`

                      if (item.pubmed) item.pubmed = `\t${item.pubmed}`

                      if (item.variantsType) item.type = t(item.variantsType)

                      // item.OMIMJSON = JSON.stringify(item.OMIM)

                      // item.LitVarArticlesSON = JSON.stringify(item.LitVarArticles)

                      // item.ArticlesJSON = JSON.stringify(item.Articles)

                      if (item.chrom)
                        item.chrom_pos = `${item.chrom}:${item.pos}`

                      if (item?.Index)
                        item.Index = `\t${item?.Index?.accountTotal} / ${item?.Index?.userTotalSamples}`

                      if (item?.GeneIndex)
                        item.GeneIndex = `\t${item?.GeneIndex?.accountTotal} / ${item?.GeneIndex?.platformTotal}`

                      //

                      if (item.allele_frequency)
                        item.Zygosity =
                          item.allele_frequency < 0.85
                            ? t('heterozygote')
                            : t('homozygote')

                      if (item.OMIM)
                        if (i18n && i18n.language === 'zh') {
                          item.OMIMValueZn = item.OMIM
                            ? item.OMIM.omimData
                                .map(
                                  (i: { pheno_name_cn: any }) => i.pheno_name_cn
                                )
                                .join('，')
                            : ''
                        } else {
                          item.OMIMValueEn = item.OMIM
                            ? item.OMIM.omimData
                                .map((i: { phenoName: any }) => i.phenoName)
                                .join('，')
                            : ''
                        }

                      delete item.gnomAD_pop_AF_hom

                      delete item.gnomAD_pop_AF_het

                      delete item.OMIM

                      delete item.LitVarArticles

                      delete item.Articles

                      delete item.transcript_list

                      return item
                    })
                    if (props.handleExportCsv) {
                      props.handleExportCsv(arr)
                      return
                    }

                    // 导出XLSX
                    const worksheet = XLSX.utils.json_to_sheet(arr)
                    const workbook = XLSX.utils.book_new()

                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

                    XLSX.writeFile(
                      workbook,
                      `${props.analysisInfo.name}-${formatDate(
                        new Date()
                      )}.xlsx`
                    )
                  }}
                >
                  {t('export')}
                </Button>
              </Box>

              {props.analysisInfo.hasThalassemiaVariants ? (
                <Box>
                  <Tabs
                    value={value2}
                    onChange={(
                      event: React.SyntheticEvent,
                      newValue: number
                    ) => {
                      setValue2(newValue)
                    }}
                    aria-label="basic tabs example"
                  >
                    {types.map((item: any, index: number) => (
                      <Tab
                        key={item}
                        label={t(item)}
                        {...a11yProps(index)}
                        sx={{
                          textTransform: 'capitalize'
                        }}
                      />
                    ))}
                  </Tabs>

                  {types.map((items: any, index: number) => {
                    const Data = data.filter(
                      (item: any) => item.variantsType === items
                    )

                    const Other = data.filter(
                      (item: any) => item.variantsType !== items
                    )
                    const thalassemiaDatas = thalassemiaData.filter(
                      (item: any) => item.variantsType === items
                    )

                    const otherThalassemiaDatas = thalassemiaData.filter(
                      (item: any) => item.variantsType !== items
                    )

                    return (
                      <CustomTabPanel key={items} value={value2} index={index}>
                        <Tabs
                          value={value}
                          onChange={handleChange}
                          aria-label="basic tabs example"
                        >
                          <Tab
                            label={t('SNV')}
                            {...a11yProps(0)}
                            sx={{
                              textTransform: 'capitalize'
                            }}
                          />

                          <Tab
                            label={t('CNV')}
                            {...a11yProps(1)}
                            sx={{
                              textTransform: 'capitalize'
                            }}
                          />

                          <Tab
                            label={t('STR')}
                            {...a11yProps(2)}
                            sx={{
                              textTransform: 'capitalize'
                            }}
                          />

                          <Tab
                            label={t('thalassemia')}
                            {...a11yProps(3)}
                            sx={{
                              textTransform: 'capitalize'
                            }}
                          />
                        </Tabs>

                        <CustomTabPanel value={value} index={0}>
                          <TanStackTable
                            columns={defaultColumns}
                            data={Data.filter((row) => row.pos)}
                            pagination={{
                              pageIndex: 1,
                              pageSize: 30
                            }}
                            pageCount={Data.length}
                            setRowSelection={(
                              rowSelection: number[],
                              keyIds: string[]
                            ) => {
                              //

                              const selectData = data
                                .filter((item: any, index: number) =>
                                  keyIds.some((i) => i === item.keyId)
                                )
                                .map((item) => {
                                  return {
                                    ...item
                                  }
                                })

                              setSelectRowKey([...selectData])
                            }}
                            setPagination={setPage}
                            setSortQuery={setSortQuery}
                            sorting={[]}
                            isFetching={false}
                            setPage={null}
                            variantCount={0}
                            totalCount={0}
                            ref={tableRef}
                            disabledExpand={true}
                            analysisInfo={props.analysisInfo}
                          />
                        </CustomTabPanel>

                        <CustomTabPanel value={value} index={1}>
                          <TanStackTable
                            columns={defaultColumns1}
                            data={Data.filter(
                              (row) => row.SV_start || row.start
                            )}
                            pagination={{
                              pageIndex: 1,
                              pageSize: 30
                            }}
                            pageCount={Data.length}
                            setRowSelection={(
                              rowSelection: number[],
                              keyIds: string[]
                            ) => {
                              //

                              const selectData = data
                                .filter((item: any, index: number) =>
                                  keyIds.some((i) => i === item.keyId)
                                )
                                .map((item) => {
                                  return {
                                    ...item
                                  }
                                })

                              setSelectRowKey([...selectData])
                            }}
                            setPagination={setPage}
                            setSortQuery={setSortQuery}
                            sorting={[]}
                            isFetching={false}
                            setPage={null}
                            variantCount={0}
                            totalCount={0}
                            ref={tableRef}
                            disabledExpand={true}
                            analysisInfo={props.analysisInfo}
                          />
                        </CustomTabPanel>

                        <CustomTabPanel value={value} index={2}>
                          <TanStackTable
                            columns={defaultColumns2}
                            data={Data.filter(
                              (row) => row.GangSTR_repcn
                            ).filter((row) => row.GangSTR_repci)}
                            pagination={{
                              pageIndex: 1,
                              pageSize: 30
                            }}
                            pageCount={Data.length}
                            setRowSelection={(
                              rowSelection: number[],
                              keyIds: string[]
                            ) => {
                              //

                              const selectData = data
                                .filter((item: any, index: number) =>
                                  keyIds.some((i) => i === item.keyId)
                                )
                                .map((item) => {
                                  return {
                                    ...item
                                  }
                                })

                              setSelectRowKey([...selectData])
                            }}
                            setPagination={setPage}
                            setSortQuery={setSortQuery}
                            sorting={[]}
                            isFetching={false}
                            setPage={null}
                            variantCount={0}
                            totalCount={0}
                            ref={tableRef}
                            disabledExpand={true}
                            analysisInfo={props.analysisInfo}
                          />
                        </CustomTabPanel>

                        <CustomTabPanel value={value} index={3}>
                          <TanStackTable
                            columns={defaultColumns3}
                            data={thalassemiaDatas}
                            pagination={{
                              pageIndex: 1,
                              pageSize: 30
                            }}
                            pageCount={thalassemiaDatas.length}
                            setRowSelection={(
                              rowSelection: number[],
                              keyIds: string[]
                            ) => {
                              //

                              const selectData = data
                                .filter((item: any, index: number) =>
                                  keyIds.some((i) => i === item.keyId)
                                )
                                .map((item) => {
                                  return {
                                    ...item
                                  }
                                })

                              setSelectRowKey([...selectData])
                            }}
                            setPagination={setPage}
                            setSortQuery={setSortQuery}
                            sorting={[]}
                            isFetching={false}
                            setPage={null}
                            variantCount={0}
                            totalCount={0}
                            ref={tableRef}
                            disabledExpand={true}
                            analysisInfo={props.analysisInfo}
                          />
                        </CustomTabPanel>
                      </CustomTabPanel>
                    )
                  })}
                </Box>
              ) : (
                <Box>
                  <Tabs
                    value={value2}
                    onChange={(
                      event: React.SyntheticEvent,
                      newValue: number
                    ) => {
                      setValue2(newValue)
                    }}
                    aria-label="basic tabs example"
                  >
                    {types.map((item: any, index: number) => (
                      <Tab
                        key={item}
                        label={t(item)}
                        {...a11yProps(index)}
                        sx={{
                          textTransform: 'capitalize'
                        }}
                      />
                    ))}
                  </Tabs>

                  {types.map((items: any, index: number) => {
                    const Data = data.filter(
                      (item: any) => item.variantsType === items
                    )

                    const Other = data.filter(
                      (item: any) => item.variantsType !== items
                    )

                    return (
                      <CustomTabPanel key={items} value={value2} index={index}>
                        <Tabs
                          value={value}
                          onChange={handleChange}
                          aria-label="basic tabs example"
                        >
                          <Tab
                            label={t('SNV')}
                            {...a11yProps(0)}
                            sx={{
                              textTransform: 'capitalize'
                            }}
                          />

                          <Tab
                            label={t('CNV')}
                            {...a11yProps(1)}
                            sx={{
                              textTransform: 'capitalize'
                            }}
                          />

                          <Tab
                            label={t('STR')}
                            {...a11yProps(2)}
                            sx={{
                              textTransform: 'capitalize'
                            }}
                          />
                        </Tabs>

                        <CustomTabPanel value={value} index={0}>
                          <TanStackTable
                            columns={defaultColumns}
                            data={Data.filter((row) => row.pos)}
                            pagination={{
                              pageIndex: 1,
                              pageSize: 30
                            }}
                            pageCount={Data.length}
                            setRowSelection={(
                              rowSelection: number[],
                              keyIds: string[]
                            ) => {
                              //

                              const selectData = data
                                .filter((item: any, index: number) =>
                                  keyIds.some((i) => i === item.keyId)
                                )
                                .map((item) => {
                                  return {
                                    ...item
                                  }
                                })

                              setSelectRowKey([...selectData])
                            }}
                            setPagination={setPage}
                            setSortQuery={setSortQuery}
                            sorting={[]}
                            isFetching={false}
                            setPage={null}
                            variantCount={0}
                            totalCount={0}
                            ref={tableRef}
                            disabledExpand={true}
                            analysisInfo={props.analysisInfo}
                          />
                        </CustomTabPanel>

                        <CustomTabPanel value={value} index={1}>
                          <TanStackTable
                            columns={defaultColumns1}
                            data={Data.filter(
                              (row) => row.SV_start || row.start
                            )}
                            pagination={{
                              pageIndex: 1,
                              pageSize: 30
                            }}
                            pageCount={Data.length}
                            setRowSelection={(
                              rowSelection: number[],
                              keyIds: string[]
                            ) => {
                              //

                              const selectData = data
                                .filter((item: any, index: number) =>
                                  keyIds.some((i) => i === item.keyId)
                                )
                                .map((item) => {
                                  return {
                                    ...item
                                  }
                                })

                              setSelectRowKey([...selectData])
                            }}
                            setPagination={setPage}
                            setSortQuery={setSortQuery}
                            sorting={[]}
                            isFetching={false}
                            setPage={null}
                            variantCount={0}
                            totalCount={0}
                            ref={tableRef}
                            disabledExpand={true}
                            analysisInfo={props.analysisInfo}
                          />
                        </CustomTabPanel>

                        <CustomTabPanel value={value} index={2}>
                          <TanStackTable
                            columns={defaultColumns2}
                            data={Data.filter(
                              (row) => row.GangSTR_repcn
                            ).filter((row) => row.GangSTR_repci)}
                            pagination={{
                              pageIndex: 1,
                              pageSize: 30
                            }}
                            pageCount={Data.length}
                            setRowSelection={(
                              rowSelection: number[],
                              keyIds: string[]
                            ) => {
                              //

                              const selectData = data
                                .filter((item: any, index: number) =>
                                  keyIds.some((i) => i === item.keyId)
                                )
                                .map((item) => {
                                  return {
                                    ...item
                                  }
                                })

                              setSelectRowKey([...selectData])
                            }}
                            setPagination={setPage}
                            setSortQuery={setSortQuery}
                            sorting={[]}
                            isFetching={false}
                            setPage={null}
                            variantCount={0}
                            totalCount={0}
                            ref={tableRef}
                            disabledExpand={true}
                            analysisInfo={props.analysisInfo}
                          />
                        </CustomTabPanel>
                      </CustomTabPanel>
                    )
                  })}
                </Box>
              )}
            </Stack>
          ) : (
            <Typography textAlign={'center'}>{t('No Results')}</Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  )
}

export default SelectReportRow
